// Optionnel : base d'URL d'un file server si tu en as un
const FILE_BASE = import.meta.env.VITE_FILE_BASE_URL || "";

/**
 * Renvoie une URL d'avatar affichable :
 * - si l'avatar est déjà une URL absolue, on la garde
 * - si c'est une base64 string (data:image/...), on la garde
 * - sinon on préfixe par FILE_BASE si dispo
 * - sinon fallback icône
 */
export default function getAvatarUrl(user, medical) {
  const pickString = (...values) =>
    values.find((value) => typeof value === "string" && value.trim()) || null;

  const profile = user?.profile || {};
  const rawUser = user?.raw || {};

  const fromMedical = pickString(
    medical?.avatar,
    medical?.avatarUrl,
    medical?.photo,
    medical?.photoUrl,
    medical?.picture,
    medical?.profilePicture,
    medical?.profilePictureUrl
  );

  const fromUser = pickString(
    user?.avatar,
    user?.avatarUrl,
    user?.photoUrl,
    user?.photoURL,
    user?.photo,
    user?.picture,
    user?.profilePictureUrl,
    user?.profilePicture,
    user?.profile_image,
    user?.imageUrl,
    user?.image,
    profile?.avatarUrl,
    profile?.avatar,
    profile?.photoUrl,
    profile?.photo,
    profile?.picture,
    rawUser?.avatarUrl,
    rawUser?.avatar,
    rawUser?.photoUrl,
    rawUser?.photo,
    rawUser?.picture
  );
  const raw = fromMedical || fromUser;

  const FALLBACK = "https://cdn-icons-png.flaticon.com/512/149/149071.png";
  if (!raw) return FALLBACK;
  
  // Check for absolute URLs
  if (/^https?:\/\//i.test(raw)) return raw;
  
  // Check for base64 data URLs
  if (/^data:image\//i.test(raw)) return raw;

  if (FILE_BASE) {
    const base = String(FILE_BASE).replace(/\/$/, "");
    const path = String(raw).replace(/^\//, "");
    return `${base}/${path}`;
  }

  return raw; // laisse tel quel si backend sait servir
}
